import {CDN_IMAGE_URL, VIEWPORT_WIDTHS} from 'configs';
import {useViewport} from 'contexts/ViewportContext';
import React, {createElement} from 'react';
import styles from './SectionAccordion.module.scss';
import {get, isEqual} from 'lodash';
import {Card, Collapse} from 'reactstrap';

import cx from 'classnames';
import MuiIcon from 'components/Icons/MuiIcon';
import {ContentBox} from 'components/Contents';
import Lottie from 'components/Lottie';
import urlJoin from 'url-join';
import SectionAccordionVideo from './SectionAccordionVideo';

/*
items : [] of {
    value: string,
    title: string,
    icon: string,
    iconProps: IconProps,
    description: string,
    image: stringUrl,
    cta: elements
},
*/

function SectionAccordion(props) {
  const {items, toggle, selected, toggleIcon, light, accent} = props;

  const {size} = useViewport();
  const isMobile = VIEWPORT_WIDTHS[size] < VIEWPORT_WIDTHS['lg'];
  const {main} = accent || {};

  return (
    <div className={styles['accordion']}>
      {items.map((item, index) => {
        const {
          value,
          title,
          image,
          content,
          description,
          icon,
          iconProps,
          cta,
          animation,
          video,
          videoProps,
        } = item;

        const isSelected = isEqual(get(selected, 'value'), value);

        return (
          <React.Fragment key={index}>
            <Card
              onClick={() => toggle(item)}
              className={cx(styles['accordion--item'], {
                [styles[`accordion--item--${main}`]]: !!main,
                [styles['accordion--item--active']]: isSelected && !light,
                [styles['accordion--item--active-light']]: isSelected && light,
                [styles[`accordion--item--active-${main}`]]:
                  isSelected && !!main,
              })}
            >
              <div className={styles['accordion--item--header']}>
                <div
                  className={cx(styles['accordion--item--header--icon'], {
                    [styles['accordion--item--header--icon--active']]:
                      isSelected && !light,
                    [styles[`accordion--item--header--icon-${main}`]]: !!main,
                  })}
                >
                  <MuiIcon name={icon} {...iconProps} />
                </div>
                <div className={cx(styles['accordion--item--header--title'])}>
                  <h5>{title}</h5>
                </div>
                {!!toggleIcon && (
                  <div
                    className={cx(styles['accordion--item--header--toggle'], {
                      [styles[`accordion--item--header--toggle--${main}`]]:
                        !!main,
                    })}
                  >
                    {isSelected && <MuiIcon name="remove" size="lg" />}
                    {!isSelected && <MuiIcon name="expand_more" size="lg" />}
                  </div>
                )}
              </div>
              <Collapse
                isOpen={isSelected}
                className={styles['accordion--item--contents']}
              >
                <div className={styles['accordion--item--contents--text']}>
                  {description}
                </div>
                {!!cta && (
                  <div className={styles['accordion--item--contents--cta']}>
                    {createElement(cta.type, {...cta.props})}
                  </div>
                )}

                {isMobile && !!image && (
                  <img src={image} alt={title} loading="lazy" />
                )}

                {isMobile && !!video && (
                  <SectionAccordionVideo
                    src={video}
                    alt={title}
                    {...videoProps}
                  />
                )}

                {isMobile && !!animation && (
                  <Lottie
                    url={urlJoin(CDN_IMAGE_URL, animation)}
                    className={styles['accordion--item--contents--animation']}
                  />
                )}
              </Collapse>
            </Card>
            {!!content && isMobile && (
              <Collapse
                isOpen={isSelected}
                className={styles['accordion--contents']}
              >
                <ContentBox className={styles['accordion--contents--box']}>
                  {content}
                </ContentBox>
              </Collapse>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}

SectionAccordion.defaultProps = {
  toggleIcon: true,
  light: false,
};

export default SectionAccordion;
